<div class="grid">
  <div class="col-12 sm:col-6 lg:col" *ngFor="let kpi of kpis">
    <div class="admsb-kpi-card"
         [style.--kpi-color]="kpi.colorTexto"
         [style.--kpi-bg]="kpi.colorFondoInsignia"
         [style.--kpi-icon]="kpi.iconoImg ? ('url(' + kpi.iconoImg + ')') : null">
      <div class="admsb-kpi-card__insignia">
        <i *ngIf="kpi.icono" [class]="kpi.icono"></i>
        <span *ngIf="kpi.iconoImg" class="admsb-kpi-card__icono-img"></span>
        <span class="admsb-kpi-card__insignia-texto">{{ kpi.insignia }}</span>
      </div>
      <div class="admsb-kpi-card__cuerpo">
        <span class="admsb-kpi-card__valor">{{ kpi.valor }}</span>
        <span class="admsb-kpi-card__etiqueta">{{ kpi.etiquetaValor }}</span>
      </div>
    </div>
  </div>
</div>

<div class="grid align-items-end" style="margin-top: 10px !important">
  <div class="col-12 md:col-4 lg:col-3">
    <div class="div-form mb-0">
      <label>{{ 'ADMINISTRADORSERVICIOSBANCARIOS.LBL_TIPODOCUMENTO' | translate }}</label>
      <p-dropdown [options]="tiposDocumento"
                  [(ngModel)]="filtroTipoDocumento"
                  placeholder="{{ 'LBL_SELECCIONE' | translate }}"
                  emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate }}"
                  emptyMessage="{{ 'LBL_SINRESULTADOS' | translate }}"
                  optionValue="value"
                  optionLabel="label">
      </p-dropdown>
    </div>
  </div>
  <div class="col-12 md:col-4 lg:col-3">
    <div class="div-form mb-0">
      <label>{{ 'ADMINISTRADORSERVICIOSBANCARIOS.LBL_NUMERODOCUMENTO' | translate }}</label>
      <input type="text" pInputText
             placeholder="{{ 'ADMINISTRADORSERVICIOSBANCARIOS.LBL_NUMERODOCUMENTO' | translate }}"
             [(ngModel)]="filtroNumeroDocumento"
             (keyup.enter)="aplicarFiltros()">
    </div>
  </div>
  <div class="col-6 md:col-2 lg:col-1">
    <button type="button" pButton
            icon="fa fa-filter"
            label="{{ 'BTN_FILTRAR' | translate }}"
            class="btn-primary-outline w-full"
            (click)="aplicarFiltros()">
    </button>
  </div>
  <div class="col-6 md:col-2 lg:col-1">
    <button type="button" pButton
            icon="fa fa-eraser"
            label="{{ 'BTN_LIMPIAR' | translate }}"
            class="btn-primary-outline w-full"
            (click)="limpiarFiltros()">
    </button>
  </div>
</div>

<div class="grid">
  <div class="col-12 md:col-12 lg:col-12">
    <p-table #tabla [value]="titulares" [lazy]="true" (onLazyLoad)="cargarPagina($event)"
             [paginator]="true" [rows]="filas" [totalRecords]="totalRegistros" [loading]="cargando"
             styleClass="ds-tabla">
      <ng-template pTemplate="header">
        <tr>
          <th>{{ 'ADMINISTRADORSERVICIOSBANCARIOS.LBL_NUMERODOCUMENTO' | translate }}</th>
          <th>{{ 'ADMINISTRADORSERVICIOSBANCARIOS.LBL_NOMBREAPELLIDO' | translate }}</th>
          <th>{{ 'ADMINISTRADORSERVICIOSBANCARIOS.LBL_METODOHABILITADO' | translate }}</th>
          <th class="text-center">{{ 'LBL_ACCIONES' | translate }}</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-titular>
        <tr>
          <td>{{ titular.codigoTipoDocumento | tipoDocumento }} {{ titular.numeroDocumento ? (titular.numeroDocumento | miles) : '' }}</td>
          <td>{{ titular.nombreCompleto }}</td>
          <td>{{ titular.metodos }}</td>
          <td class="text-center">
            <button type="button"
                    class="btn-action-premium ds-btn-icono-editar"
                    title="{{ 'BTN_EDITAR' | translate }}"
                    (click)="editar(titular)">
              <span class="ds-icono-editar"></span>
            </button>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="4" class="text-center">{{ 'MSG_NOHAYREGISTROS' | translate }}</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
